import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../components_root/ToastContext.jsx';
import { MdClose, MdFileDownload, MdHistory, MdOutlineLocalPrintshop, MdPrint, MdSearch } from "react-icons/md";
import ShareButton from "../components_root/ShareButton.jsx";
import { Timestamp } from "firebase/firestore";
import Print_receipt_order from "../accounting_root/print_root/print_receipt_order.js";
import Print_receipt_a4 from "../accounting_root/print_root/print_receipt_a4.js";
import Ledger_accounts_reports_profile from "../company_root/staff_account_root/ledger_accounts_reports_profile.jsx";

import Settingprint_popup from "../accounting_root/print_setting_root/settingprint_popup.jsx";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import CopyUID from "../components_root/copyuid.jsx";
import { No_transactions } from "../components_root/no_transactions.jsx";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function POS_receipt_transaction() {
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [amount, setAmount] = useState(0);
    const [transaction, setTransaction] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [voucherlist, setVoucherlist] = useState([]);
    const [voucherselected, setVoucherselected] = useState("All Receipts");
    const [reportsrata, setReportsData] = useState([]);
    const [printpage, setPrintpage] = useState("receipts");
    const [printapply, setPrintapply] = useState("");
    const [printid, setPrintid] = useState("");
    const navigate = useNavigate();
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    const servicetablename = "accountingfinancedb";
    const [settingprintopen, setSettingprintopen] = useState(false);
    const [indexmode, setindexmode] = useState(true);
    const [select_company_uid, setSelect_company_uid] = useState(null);
    const [guid, setGuid] = useState(null);

    useEffect(() => {
        setGuid(Cookies.get("guid"));
    }, []);

    useEffect(() => {
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    //
    useEffect(() => {

        const today = new Date();
        const firstDay =
            today.getFullYear() +
            "-" +
            String(today.getMonth() + 1).padStart(2, "0") +
            "-01";
        const currentDay = today.toISOString().slice(0, 10);
        setFrom_date(currentDay);
        setTo_date(currentDay);
    }, []);


    useEffect(() => {
        if (!select_company_uid || !guid || !printpage) return;

        const applyQuery = query(
            collection(
                db,
                servicetablename,
                select_company_uid,
                "print_settings_account_apply"
            ),
            where("guid", "==", guid),
            where("status", "==", true),
            where("printpage", "==", printpage)
        );

        const unsubscribe = onSnapshot(
            applyQuery,
            (snapshot) => {
                if (snapshot.empty) {
                    setPrintapply(null);
                    return;
                }
                setPrintapply(snapshot.docs[0]?.data()?.printsize ?? null);
                setPrintid(snapshot.docs[0]?.data()?.printid ?? null);
            },
            (error) => {
                console.error("Print apply listener error:", error);
                setPrintapply(null);
            }
        );

        return unsubscribe;
    }, [select_company_uid, guid, printpage]);
    const [printdata, setPrintdata] = useState([]);
    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, "accountingfinancedb", select_company_uid, "print_setting"), where("printid", "==", printid)
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

            const settingArray = data[0]?.settingdata || [];

            // convert back to object
            const settingObj = Object.fromEntries(
                settingArray.map(item => [item.key, item.value])
            );

            setPrintdata(settingObj);
        });

        return () => unsub();
    }, [select_company_uid, printid]);

    const get_Reports = () => {
        // Load print settings

        if (!select_company_uid || !from_date || !to_date) return;

        setIsLoading2(true);
        const startTimestamp = Timestamp.fromDate(new Date(`${from_date}T00:00:00`));
        const endTimestamp = Timestamp.fromDate(new Date(`${to_date}T23:59:59`));
        const baseRef = collection(
            db,
            servicetablename,
            select_company_uid,
            "voucher_print"
        );
        const constraints = [
            where("guid", "==", guid),
            where("date_time", ">=", startTimestamp),
            where("date_time", "<=", endTimestamp),
        ];

        // 🔹 Voucher filters
        if (voucherselected && voucherselected !== "All Transaction" && voucherselected !== "All Receipts") {
            constraints.push(where("voucher", "==", voucherselected));
        }

        if (voucherselected === "All Receipts") {
            constraints.push(where("receiptstatus", "==", true));
        }

        // 🔹 Order LAST (Firestore rule)
        constraints.push(
            orderBy("date_time", indexmode ? "desc" : "asc")
        );
        const productQuery = query(baseRef, ...constraints);

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map(d => ({
                    id: d.id,
                    ...d.data(),
                }));

                let total = 0;
                vouchers.forEach(v => total += Number(v?.totalamount || 0));

                setReportsData(vouchers);
                setTransaction(vouchers.length);
                setAmount(total);

                setVoucherlist(prev => {
                    const set = new Set(prev);
                    vouchers.forEach(v => v?.voucher && set.add(v.voucher));
                    return Array.from(set);
                });

                setIsLoading2(false);
            },
            (error) => {
                console.error("Report error:", error);
                setIsLoading2(false);
            }
        );

        return unsubscribe;
    };


    useEffect(() => {
        const unsub = get_Reports();
        return () => unsub && unsub();
    }, [select_company_uid, from_date, to_date, voucherselected, indexmode]);


    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const safeFirstCap = (text = "") => {
        if (typeof text !== "string") return "";
        if (text.length === 0) return "";

        // Only apply capitalization for English letters
        if (/^[a-z]/i.test(text)) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }

        // Return unchanged for non-English (Unicode)
        return text;
    };

    // Function to load local font file and convert to base64
    const downloadPDF = () => {
        if (!reportsrata || reportsrata.length === 0) {
            alert("No data to generate report");
            return;
        }

        // Build table rows
        const tableRows = reportsrata.map((row) => {
            const dateTime = row.date_time?.toDate
                ? `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                : "No date";

            return `
            <tr>
                <td class="bold">${row.tokennumber || "0"}</td>
                <td>
                   <a class="bold"> ${row.vouchernumber || "0"}</a><br/>
                    <span class="text-h4">${dateTime}</span>
                </td>
                <td class="fcap">${row.voucher || "N/A"}</td>
                <td >
                   <a class="text-h2 bold fcap"> ${row.namepaying || "N/A"}</a><br/>
                    ${row.code || ""} ${row.mobile || ""}
                </td>
                <td>${row.refer_number || "N/A"}<br/>
           <div class="text-h3">${row?.remarks || ""}</div>
                </td>

                <td ><a class="text-h2 bold">₹${row.totalamount || 0}/-</a>
                <br/>
             ${row?.payment_method_online
                    ? `<div class="text-h3">Online</div>`
                    : `<div class="text-h3">Cash</div>`
                }
                </td>
            </tr>
        `;
        }).join("");

        // Total amount
        const totalAmount = reportsrata.reduce(
            (sum, row) => sum + (parseFloat(row.totalamount) || 0),
            0
        );

        const content = `
        <div>
            <!-- HEADER -->
            <table>
                <tr>
                    <td>
                        <div class="title_sub">${printdata.print_title || "Receipt Transaction Report"}</div>
                        <div class="text-h2">${printdata.print_tagline || ""}</div>
                        <div class="text-h3">${printdata.print_contactinfo || ""}</div>
                        <div class="text-h3 bold">${printdata.print_address || ""}</div>
                    </td>
                    <td style="text-align:right">
                        <div class="text-h2">Report Type: <b>${voucherselected}</b></div>
                        <div class="text-h2">Period: <b>${from_date} to ${to_date}</b></div>
                        <div class="text-h2 bold p-top">Transaction: ${transaction} | Amount: ₹${amount}/-</div>
                        <div class="text-h3">Print ${new Date().toLocaleString()}</div>
                    </td>
                </tr>
            </table>

            <!-- TITLE -->
            <div class="items-back-fill"> 

                <!-- TABLE -->
                <table class="report-table">
                    <thead>
                        <tr>
                            <th>Token</th>
                            <th>Receipt No.</th>
                            <th>Receipt</th>
                            <th>Name</th>
                            <th>Refer No.</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows}
                    </tbody> 
                </table>
            </div>

            <!-- FOOTER -->
            <table class="p-2">
                 <tr>
                  <td  class=" bold text-h2">Service by: Aooz.in</td>
                 <td width={120} class="text-h2 bold" ><div style={{ textAlign: "right" }}>Total Amount: ${totalAmount}</div></td></tr>
                 
            </table>
        </div>
    `;

        const printWindow = window.open("", "", "width=1200,height=800");
        printWindow.document.write(`
        <html>
        <head>
            <title>Report</title>
            <style>
                @page {
                    size: A4 portrait;
                    margin: 10mm;
                }

                body {
                    font-family: Arial, sans-serif;
                    margin: 0;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    page-break-inside: auto;
                }

                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }

                tr { page-break-inside: avoid; }

                .report-table th,
                .report-table td {
                    border: 1px solid #ccc;
                    padding: 6px;
                    font-size: 11px;
                    word-break: break-word;
                }

                .report-table thead tr,
                .report-table tfoot tr {
                    background: #f0f0f0;
                }

                .bold { font-weight: bold; }
                .center { text-align: center; }
                .fcap { text-transform: capitalize; }

                .title_sub { font-size: 18px; font-weight: bold; }
                .text-h2 { font-size: 12px; }
                .text-h3 { font-size: 10px; }
                .text-h4 { font-size: 9px; }

                .items-back-fill {
                    border: 1px solid #000;
                    margin: 10px 0;
                }

                .line-top2 { border-top: 2px solid #000; }
                .p-1 { padding: 8px; }
            </style>
        </head>
        <body>${content}</body>
        </html>
    `);

        printWindow.document.close();
        // printWindow.focus();
        printWindow.print();
    };


    const [voucherprintid, setVoucherprintid] = useState();

    const PrintReceiptVoucher = (id) => {
        setVoucherprintid(id);
        const timer = setTimeout(() => {
            setVoucherprintid("");
        }, 2000);
    };

    return (
        <div >


            <div className="items-back">
              
                <div className="post-container ">
                    <div className="ui-grid">
                        <div className="ui-items items-back p-11">
                            <table>
                                <tr>
                                    <td className="text-h2 text-off">Transaction</td>
                                    <td>  <div className="text-h2 bold">{transaction}</div></td>
                                </tr>
                                <tr>
                                    <td className="text-h2 text-off">Amount</td>
                                    <td>  <div className="text-h2 bold">₹{amount}/-</div></td>
                                </tr>
                            </table>
                        </div>
                        <div className="ui-items items-back p-11">
                            <select className="text-h2 bold p-11" onChange={(e) => setVoucherselected(e.target.value)}>
                                <option value={"All Receipts"}>All Receipts</option>
                                <option value={"All Transaction"}>All Transaction</option>
                                {voucherlist.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                            <table>
                                <tr>
                                    <td>
                                        <input
                                        className="text-h2 bold"
                                            value={from_date}
                                            type="date"
                                            onChange={(e) => setFrom_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <input
                                          className="text-h2 bold"
                                            value={to_date}
                                            type="date"
                                            onChange={(e) => setTo_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <div
                                            onClick={() => get_Reports()}

                                            className="button-ui2 p-11">
                                            <MdSearch className="icon cursor" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                       
                        <div className="ui-items items-back p-11">
                            <table>
                                <tr>
                                    <td>
                                        <div className="button-ui2 p-1 cursor" title="Download PDF"
                                            onClick={downloadPDF}

                                        >
                                            <MdFileDownload className="icon cursor" />PDF Download
                                        </div>
                                    </td>
                                    {/* <td width={100}>
                                        <div className="button-ui p-1 cursor"
                                            onClick={() => {
                                                setSettingprintopen(true);
                                            }}
                                        >
                                            <MdOutlineLocalPrintshop className="icon cursor" />Set <div className="bold">{printapply}</div>
                                        </div>
                                    </td> */}
                                </tr>
                            </table>


                        </div>
                    </div>

                </div>
                <div className="post-container">
                    <div className="post_div">
                        {IsLoading2 ? (
                            <></>
                        ) : !reportsrata || reportsrata.length === 0 ? (
                            <div className="ui-grid-fill">
                                <No_transactions message="Receipts " />
                            </div>
                        ) : (    // ============================
                            // DESKTOP VIEW
                            // ============================
                            <div >
                                {window.innerWidth > 768 ? (
                                    <div className="ui-grid-fill ">

                                        <table className="voucher-table-desktop">
                                            <thead >
                                                <tr >
                                                    <th>
                                                        <div
                                                            className="button-ui0 p-0 cursor bold"
                                                            onClick={() => setindexmode(prev => !prev)}
                                                        >
                                                            Token
                                                            {indexmode ? (
                                                                <TiArrowSortedUp className="icon green" />
                                                            ) : (
                                                                <TiArrowSortedDown className="icon red" />
                                                            )}
                                                        </div>
                                                    </th> 
                                                    <th>Receipt no.</th>
                                                    <th>Receipt</th>
                                                    <th>Paying Name</th>
                                                    <th>Refer no.</th>
                                                    <th>Amount</th>
                                                    <th>Pay</th>
                                      
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {reportsrata.map((row) => (
                                                    <tr className="tr_hover ease-in-out"
                                                        key={row.voucherprintid}

                                                    >
                                                        <td width={30} className="bold text-h2 p-11">
                                                            {row.tokennumber || "0"}
                                                        </td>
                                                     
                                                        <td width={140} className="text-h3">

                                                            <div className="button-ui0">{row.vouchernumber || "0"}<CopyUID id={row.vouchernumber} /></div>
                                                            <div width={130} className="text-h3">
                                                                {row.date_time?.toDate ? (
                                                                    <>
                                                                        {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                        {row.date_time.toDate().toLocaleTimeString()}
                                                                    </>
                                                                ) : (
                                                                    "No date"
                                                                )}
                                                            </div>
                                                        </td>


                                                        <td className="bold text-h2 fcap">{row.voucher || "N/A"}</td>

                                                        <td><a className="bold text-h2 fcap">{row.namepaying || "N/A"}</a>
                                                            <br />
                                                            <div className="text-h3">{row.code}{row.mobile || ""}</div>
                                                        </td>

                                                        <td ><a className="text-h2">{row.refer_number || " N/A"}</a><br /><div className="text-h3">{row.remarks || ""}</div></td>


                                                        <td width={60} className="text-h2 bold">
                                                            ₹{row.totalamount || 0}/-
                                                        </td>
                                                        <td width={60} className="text-h2">

                                                            {row.payment_method_online ? <div className="text-h2 green">Online</div> : <div className="text-h2 red">Cash</div>}
                                                        </td>
                                                     
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    // ============================
                                    // MOBILE VIEW: Card UI
                                    // ============================
                                    reportsrata.map((row) => (
                                        <div
                                            key={row.voucherid}
                                            title="Click"

                                            className="ui-items items-back p-1 b-1 m-1 hover shadow rounded"
                                        >
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="text-h2 bold fcap">
                                                                {row.voucher || "Voucher Not Found"}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <div className="text-h2 fcap bold">
                                                                                {row.namepaying || "No Name"}
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-r text-h2">
                                                                            {row.code}{row.mobile || "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <table className="b-top">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <div className="text-h3 bold">
                                                                                Token #{row.tokennumber || "0"}
                                                                            </div>
                                                                        </td>

                                                                        <td width={140} className="text-h4 text-r text-off">
                                                                            {row.date_time?.toDate ? (
                                                                                <>
                                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                                </>
                                                                            ) : (
                                                                                "No date"
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <table className="b-top">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <div className="text-h2 bold">
                                                                                ₹{row.totalamount || "0"} /-
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="text-h4 text-r text-off">
                                                                                ID: {row.voucherprintid || "0"}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ))
                                )}
                            </div>
                        )}



                    </div>
                </div>
            </div>
            {voucherprintid && printapply == "4INCH" && (
                <Print_receipt_order voucherprintid={voucherprintid} printid={printid} />
            )}
            {voucherprintid && printapply == "A4" && (
                <Print_receipt_a4 voucherprintid={voucherprintid} printid={printid} />
            )}
            <Settingprint_popup data={printpage} isOpen={settingprintopen} onClose={() => setSettingprintopen(false)} />
        </div>
    );
}
